import { render, staticRenderFns } from "./select-partner-clinic.vue?vue&type=template&id=2dee7f49&"
import script from "./select-partner-clinic.vue?vue&type=script&lang=js&"
export * from "./select-partner-clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports